import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, API, fmtDDMMYYYY } from "../../api";
import { PageHeader, Panel, Btn, Input, Select, Empty, Pill } from "../../ui";

export default function BusinessesPage() {
  const [list, setList] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [show, setShow] = useState(false);
  const [f, setF] = useState({ legal_name: "", trading_name: "", structure: "ltd", company_number: "", trading_address: "", industry: "", trading_start_date: "", linked_customer_ids: [] });
  const load = async () => {
    const [a, b] = await Promise.all([api.get(`${API}/businesses`), api.get(`${API}/customers`)]);
    setList(a.data); setCustomers(b.data);
  };
  useEffect(() => { load(); }, []);
  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post(`${API}/businesses`, f);
      toast.success("Business saved");
      setShow(false);
      setF({ legal_name: "", trading_name: "", structure: "ltd", company_number: "", trading_address: "", industry: "", trading_start_date: "", linked_customer_ids: [] });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Could not save"); }
  };
  return (
    <div>
      <PageHeader title="Businesses" subtitle="Trading entities linked to one or more customers. Each business can have multiple finance applications." action={<Btn onClick={() => setShow(true)}>+ New business</Btn>} />
      {show && (
        <Panel className="p-6 mb-6">
          <form onSubmit={create} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input label="Legal name" required value={f.legal_name} onChange={(e) => setF({ ...f, legal_name: e.target.value })} />
            <Input label="Trading name" value={f.trading_name} onChange={(e) => setF({ ...f, trading_name: e.target.value })} />
            <Select label="Structure" value={f.structure} onChange={(e) => setF({ ...f, structure: e.target.value })}>
              <option value="ltd">Limited company</option>
              <option value="sole_trader">Sole trader</option>
              <option value="partnership">Partnership</option>
              <option value="llp">LLP</option>
            </Select>
            <Input label="Company number" value={f.company_number} onChange={(e) => setF({ ...f, company_number: e.target.value })} />
            <Input label="Industry" value={f.industry} onChange={(e) => setF({ ...f, industry: e.target.value })} />
            <Input label="Trading start date" type="date" value={f.trading_start_date} onChange={(e) => setF({ ...f, trading_start_date: e.target.value })} />
            <div className="sm:col-span-2"><Input label="Trading address" value={f.trading_address} onChange={(e) => setF({ ...f, trading_address: e.target.value })} /></div>
            <div className="sm:col-span-2 flex justify-end gap-2 pt-2">
              <Btn variant="ghost" type="button" onClick={() => setShow(false)}>Cancel</Btn>
              <Btn type="submit">Save</Btn>
            </div>
          </form>
        </Panel>
      )}
      {list === null && <p className="text-sm text-slate-500">Loading…</p>}
      {list && list.length === 0 && <Empty title="No businesses yet" hint="Add one when a customer brings a trading entity to finance." />}
      {list && list.length > 0 && (
        <Panel>
          <table className="w-full text-sm">
            <thead><tr className="border-b border-slate-200 text-[10.5px] tracking-[0.14em] uppercase text-slate-500 bg-slate-50"><th className="text-left px-5 py-3">Name</th><th className="text-left px-5 py-3">Structure</th><th className="text-left px-5 py-3">Industry</th><th className="text-left px-5 py-3">Trading since</th></tr></thead>
            <tbody>
              {list.map((b) => (
                <tr key={b.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-5 py-3 font-medium">{b.legal_name}{b.trading_name && <span className="text-slate-500"> · {b.trading_name}</span>}</td>
                  <td className="px-5 py-3"><Pill tone="sky">{b.structure}</Pill></td>
                  <td className="px-5 py-3 text-slate-600">{b.industry || "—"}</td>
                  <td className="px-5 py-3 text-slate-600">{fmtDDMMYYYY(b.trading_start_date)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Panel>
      )}
    </div>
  );
}
